
<app-Login *ngIf="showLogin && !pdfBackup"></app-Login>

<mat-grid-list cols="18" *ngIf="!showLogin && !acceptedCookie">
  <app-cookie></app-cookie>
</mat-grid-list>

<mat-grid-list cols="18" rowHeight="100%" gutterSize="0" *ngIf="showLogin && pdfBackup">
  <mat-grid-tile colspan="3" class="leftNavTileColor">
    <app-left-side-menu class="fullComponent"></app-left-side-menu>
  </mat-grid-tile>
  <mat-grid-tile colspan="15" [ngClass]="acceptedCookie?'pos-fixed':''">
    <div class="fullComponent flex-display flex-direction-column">
      <app-main-content (scrollStatus)="ShowTopButton($event)" class="main-content overflow-auto background-white"></app-main-content>
      <app-scroll-to-top [windowScrolled]="windowScrolled"></app-scroll-to-top>
    </div>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="18" rowHeight="100%" gutterSize="0" *ngIf="!showLogin">
  <mat-grid-tile colspan="3" class="leftNavTileColor">
    <app-left-side-menu class="fullComponent"></app-left-side-menu>
  </mat-grid-tile>
  <mat-grid-tile colspan="15" [ngClass]="acceptedCookie?'pos-fixed':''">
    <div class="fullComponent flex-display flex-direction-column">
      <app-back-button *ngIf="IsCrossRef || IsGlossary || IsWhatLinksHere || IsXbrl" [GlossaryTerm]="IsGlossary" [WhatLinksHere]="IsWhatLinksHere" [crossRef]="IsCrossRef" [Xbrl]="IsXbrl" [whatLinksHereUrl]="whatLinksHereBackButtonUrl" [whatLinksHereTitle]="whatLinksHereBackButtonTitle"></app-back-button>
      <app-main-content (scrollStatus)="ShowTopButton($event)" class="main-content overflow-auto background-white" [ngClass]="{'pcs_border_highligh': isPendingContentPage,'archive_highlight':isArchive}"></app-main-content>
      <app-scroll-to-top [windowScrolled]="windowScrolled"></app-scroll-to-top>
      <app-footer class="footer display-content" (callROC)="invokerocMethod($event)"></app-footer>
    </div>
  </mat-grid-tile>
</mat-grid-list>
<app-right-overlay></app-right-overlay>
<app-notification></app-notification>


